import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ProductContainer from "../containers/ProductContainer";
import AddProductContainer from "../containers/AddProductContainer";
import FileMangerContainer from "../containers/FileManagerContainer";
import UserStorageContainer from "../containers/UserStorageContainer";
import UserImgcreditContainer from "../containers/UserImgcreditContainer";
import AdminContainer from "../containers/AdminContainer";
import { ENDPOINTS } from "../constants/endpoints";
import { FormGroup, ControlLabel, FormControl, Modal } from "react-bootstrap";

export default class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      subscription_id: "",
      subscription_status: "",
      sub_role: "N",
      sub_avail_space: -1.0,
      showEnhance: false,
      isBatchModal: false,
      batches: [],
      isImageFiles: false,
      isErrorDetails: false,
      imageFiles: [],
      errorDetails: [],
      aiExpand: false
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.products !== this.state.products) {
      this.setState({ products: nextProps.products });
    }
  }
  UNSAFE_componentWillMount() {
    let user_role = document.getElementById("user_role");
    user_role = user_role.innerHTML;
    let preset_product_id = document.getElementById("preset_product_id");
    preset_product_id = preset_product_id ? preset_product_id.innerHTML : null;
    user_role = preset_product_id ? "preset" : user_role;
    localStorage.setItem("preset_product_id", preset_product_id);
    this.setState({
      role: user_role,
      preset_product_id: preset_product_id || null
    });
    if (preset_product_id) {
      this.props.getProducts({ type: "presets" });
    } else this.props.getProducts();
  }

  componentDidMount() {
    this.getsubidfromDB();
  }

  getsubidfromDB = () => {
    let subid_uri = ENDPOINTS.subid.index.uri;
    let noRecords;

    (async () => {
      noRecords = await fetch(subid_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            subscription_id: data.sub_id,
            subscription_status: data.sub_status,
            sub_avail_space: data.sub_avail_space,
            sub_role: data.sub_id.split("-")[0]
          });
          if (
            parseInt(data.sub_id.split("-")[1]) !== 0 &&
            data.sub_avail_space <= 0.0
          ) {
            alert(
              "Your Available Space have fallen below ZERO!!!!\nPlease purchase additional Spcae immediately\nAlternatively, Free Up Space by 'Unfreezing Product(s) or Deleting Products"
            );
          }
        });
    })();
  };

  showEnhanceOptions = () => {
    // alert("Coming Soon...");
    // return;
    this.setState({ showEnhance: !this.state.showEnhance });
    if (
      this.state.sub_role == "M" &&
      parseInt(this.state.subscription_id.split("-")[1]) !== 0 &&
      !this.state.showEnhance
    ) {
      alert(
        "Please note: Only Subscription 'ADMIN' user can purchase Image Credits!"
      );
      return;
    }
  };

  showBatchModal = () => {
    this.getBatchEnhancefromDB();
    // this.setState({ isBatchModal: !this.state.isBatchModal });
  };

  showImageFiles = () => {
    this.setState({ isImageFiles: !this.state.isImageFiles });
  };

  showErrorDetails = () => {
    this.setState({ isErrorDetails: !this.state.isErrorDetails });
  };

  getBatchEnhancefromDB = () => {
    let batchenhance_uri = ENDPOINTS.batch_enhance.index.uri;
    var user_id = this.props.user_id;

    var where = "user_id=" + user_id;
    var where = "";

    batchenhance_uri = `${batchenhance_uri}?${where}`;

    let noRecords;

    noRecords = fetch(batchenhance_uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          batches: data.batches,
          isBatchModal: !this.state.isBatchModal
        });
        console.log(`batches = ${data.batches}`);
      });
  };

  getExpandJSX = (expandFlag) => {
    return (
      <span>
        {expandFlag && (
          <i
            className="icon-collapse"
            aria-hidden="true"
            style={{ color: "black" }}
          ></i>
        )}
        {!expandFlag && (
          <i
            className="icon-expand"
            aria-hidden="true"
            style={{ color: "black" }}
          ></i>
        )}
      </span>
    );
  };

  resetDefaults = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let uri = ENDPOINTS.user_storages.update_defaults.uri;
    let that = this;
    let formData = new FormData();
    formData.append("type", "reset_defults");
    return fetch(uri, {
      method: "PUT",
      body: formData
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.data == "success") alert("Space reset successful");
      });
  };

  render() {
    const { role, preset_product_id, sub_role } = this.state;
    const sub_id = parseInt(this.state.subscription_id.split("-")[1]);
    return (
      <Fragment>
        {sub_id === 0 ||
        (sub_id != 0 && this.state.subscription_status != "EXPIRED") ? (
          <div style={{ marginBottom: "20px" }}>
            {" "}
            <h3
              className="list-heading"
              style={{
                margin: "20px 0 0px 0",
                background: "#ccc",
                fontSize: "18px",
                padding: "5px 10px",
                textAlign: "center",
                userSelect: "none"
              }}
            >
              {preset_product_id ? "Presets" : "My Products"}
            </h3>
            <ul className="tree" style={{ padding: "15px 0" }}>
              {/* {this.state.products.map((p, i) => (
            <ProductContainer key={p.id} {...p} role={role} />
          ))} */}
              {this.state.products.map((p, i) => {
                if (p.is_archived) {
                  return null;
                } else {
                  return (
                    <ProductContainer
                      key={p.id}
                      {...p}
                      role={p && p.product_state != "edit" ? "preset" : role}
                    />
                  );
                }
              })}

              {(role === "admin" || role === "owner") &&
                ((sub_id !== 0 && this.state.sub_avail_space > 0) ||
                  sub_id === 0) && (
                  <AddProductContainer
                    labelText="Add new product"
                    products={this.state.products}
                  />
                )}
              {!preset_product_id && (
                <React.Fragment>
                  <FileMangerContainer
                    labelText="View Image Files"
                    products={this.state.products}
                  />

                  <li>
                    <a onClick={this.showEnhanceOptions}>
                      {this.getExpandJSX(this.state.showEnhance)} AI Enhance
                    </a>
                    {this.state.showEnhance ? (
                      <ul className="tree" style={{ marginLeft: "15px" }}>
                        {/* <li> */}
                        {/* <a href="/enhance">{"Buy Image Credits"}</a> */}
                        {((sub_id != 0 && sub_role == "Y") || sub_id === 0) && (
                          <UserImgcreditContainer
                            labelText="Buy Image Credits"
                            products={this.state.products}
                          />
                        )}
                        {/* </li> */}
                        <li>
                          <a href="/enhance">{"Enhance Image Files"}</a>
                        </li>
                        <li>
                          <a onClick={this.showBatchModal}>
                            {"View Batch Status"}
                          </a>
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>

                  <li>
                    <a href="/cropper">{"AI Batch Crop Studio"}</a>
                  </li>

                  <UserStorageContainer
                    labelText="Buy More storage"
                    products={this.state.products}
                  />
                  {role === "admin" && (
                    <AdminContainer
                      labelText="Set Admin Defaults"
                      products={this.state.products}
                    />
                  )}
                  {role === "admin" && (
                    <li>
                      <a onClick={this.resetDefaults}>{"Reset Defaults"}</a>
                    </li>
                  )}
                </React.Fragment>
              )}
            </ul>
            <Modal
              dialogClassName="modal-90w"
              centered="true"
              show={this.state.isImageFiles}
              onHide={this.showImageFiles}
              style={{ top: "75px", width: "90%", left: "50px" }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Image Files - Submited for AI Enhance</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.imageFiles.map((item) => {
                  return (
                    <li style={{ listStyleType: "none" }}>
                      {item.replace(/"/g, "")}
                    </li>
                  );
                })}
              </Modal.Body>
            </Modal>
            <Modal
              dialogClassName="modal-90w"
              centered="true"
              show={this.state.isErrorDetails}
              onHide={this.showErrorDetails}
              style={{ top: "75px", width: "90%", left: "50px" }}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Error Deatils - Received from Google Gemini 3 Pro Render
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.errorDetails.map((item) => {
                  return <li style={{ listStyleType: "none" }}>{item}</li>;
                })}
              </Modal.Body>
            </Modal>
            <Modal
              dialogClassName="modal-90w"
              centered="true"
              show={this.state.isBatchModal}
              onHide={this.showBatchModal}
            >
              <Modal.Header closeButton>
                {/* Optional: Add a title to the modal */}
                <Modal.Title>Enhance Batch Status</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <table style={{ width: "100%", tableLayout: "auto" }}>
                  <thead style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Id
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Count
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Started At
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Finished At
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Run Status
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Finish Status
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Credits Used
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Success Count
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Failed Count
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Credits Refunded
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Image Files
                      </th>
                      <th style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        Error Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.batches.map((item) => {
                      return (
                        <tr>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {item.id}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {item.batch_count}
                          </td>
                          <td
                            style={{
                              width: "11%",
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {item.started_at}
                          </td>
                          <td
                            style={{
                              width: "11%",
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {item.finished_at}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px",
                              color:
                                item.run_status === "Processing" ? "green" : ""
                            }}
                          >
                            {item.run_status}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px",
                              color:
                                item.finish_status !== "JOB_STATE_SUCCEEDED"
                                  ? "red"
                                  : ""
                            }}
                          >
                            {item.finish_status}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {item.imgcredits_deducted}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {item.success_count}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px",
                              color: item.failed_count > 0 ? "red" : ""
                            }}
                          >
                            {item.failed_count}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px",
                              color: item.imgcredits_refunded > 0 ? "green" : ""
                            }}
                          >
                            {item.imgcredits_refunded}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {
                              <a
                                className="no-textcolor"
                                onClick={() => {
                                  this.setState({
                                    isImageFiles: true,
                                    imageFiles: item.image_files.split(",")
                                  });
                                }}
                                style={{ color: "Blue" }}
                              >
                                View Files
                              </a>
                            }
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              paddingLeft: "5px",
                              paddingRight: "5px"
                            }}
                          >
                            {item.error_details !== null ? (
                              <a
                                className="no-textcolor"
                                onClick={() => {
                                  this.setState({
                                    isErrorDetails: true,
                                    // errorDetails: item.error_details.split("Rejected"),
                                    errorDetails:
                                      item.error_details.split(/\r?\n/)
                                  });
                                }}
                                style={{ color: "Red" }}
                              >
                                Error Details
                              </a>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Modal.Body>
            </Modal>
          </div>
        ) : (
          <div>
            <h4 style={{ color: "red", fontSize: "25px", fontWeight: "bold" }}>
              Your Subscription has Expired! Please renew immediately.
            </h4>
          </div>
        )}
      </Fragment>
    );
  }
}
ProductList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      collapse: PropTypes.bool,
      product_datalevels: PropTypes.array
    })
  )
};
